import React, {useContext} from 'react'
import {defineMessages, FormattedMessage} from 'react-intl'
import Facebook from '../../../assets/brands/Facebook.svg'
import Twitter from '../../../assets/brands/Twitter.svg'
import Google from '../../../assets/brands/google.png'
import {GaEventAction, GaEventCategory, GaEventLabel, SocialProvider, socialProviderNames, urlPrefixes} from '../../../config/constants'
import {locationToString, queryToUrl} from '../../../helpers/coreUtil'
import {II18nMessage} from '../../../reducers/i18n'
import {RouterContext} from '../../containers/Context'
import {useLocale, useQuery, useUserType} from '../../hocs/hooks'
import styles from './SocialButtons.scss'

const useSocialLoginUrl = (name: SocialProvider) => {
  const userType = useUserType()
  const locale = useLocale()
  const query = useQuery()
  const {location} = useContext(RouterContext)!
  return queryToUrl(`/${locale}${urlPrefixes[userType]}/auth/${name}`, {
    redirectTo: query.redirectTo || locationToString(location)
  })
}

export const socialButtonsMessages = defineMessages({
  signup: {
    id: 'signup.socialLoginLabel',
    defaultMessage: 'Sign up with {name}'
  },
  login: {
    id: 'login.socialLoginLabel',
    defaultMessage: 'Sign in with {name}'
  }
})

const SocialButtons = (
  {label}: { label: II18nMessage }
) => {
  const fbUrl = useSocialLoginUrl(SocialProvider.facebook)
  const twUrl = useSocialLoginUrl(SocialProvider.twitter)
  const ggUrl = useSocialLoginUrl(SocialProvider.google)
  const userType = useUserType()
  const socialButtonClicked = (provider: SocialProvider) => {
    if (label === socialButtonsMessages.signup) {
      window.dataLayer.push({
        event: 'event',
        eventProps: {
          category: GaEventCategory.engagement,
          label: GaEventLabel.signup,
          action: GaEventAction[userType][GaEventLabel.signup][provider],
        }
      })
    }
  }
  return <>
    <div className="d-flex align-items-center my-3">
      <div className="bg-lightgray flex-grow-1 h-1"/>
      <div className="mx-3">
        <FormattedMessage id="login.orText" defaultMessage="or"/>
      </div>
      <div className="bg-lightgray flex-grow-1 h-1"/>
    </div>
    <div className={styles.socials}>
      <div className={styles.spaceFix}>
        <a href={fbUrl} className={[
          'btn d-flex align-items-center justify-content-center',
          styles.outline,
          styles.socialButtonField
        ].join(' ')} onClick={() => socialButtonClicked(SocialProvider.facebook)}>
          <Facebook className={[styles.loginIcon, styles.facebook].join(' ')}/>
          <FormattedMessage
            {...label}
            values={{name: socialProviderNames[SocialProvider.facebook]}}/>
        </a>
        <a href={twUrl} className={[
          'btn d-flex align-items-center justify-content-center',
          styles.outline, styles.socialButtonField
        ].join(' ')} onClick={() => socialButtonClicked(SocialProvider.twitter)}>
          <Twitter className={[styles.loginIcon, styles.twitter].join(' ')}/>
          <FormattedMessage
            {...label}
            values={{name: socialProviderNames[SocialProvider.twitter]}}/>
        </a>
        <a href={ggUrl} className={[
          'd-flex align-items-center justify-content-center',
          styles.outline, styles.socialButtonField
        ].join(' ')} onClick={() => socialButtonClicked(SocialProvider.google)}>
          <img src={Google} alt="Google" className={styles.loginIcon}/>
          <FormattedMessage
            {...label}
            values={{name: socialProviderNames[SocialProvider.google]}}/>
        </a>
      </div>
    </div>
  </>
}
SocialButtons.displayName = 'SocialButtons'
export default SocialButtons
